import { render, staticRenderFns } from "./giderGrup.vue?vue&type=template&id=5853095e&scoped=true&"
import script from "./giderGrup.vue?vue&type=script&lang=js&"
export * from "./giderGrup.vue?vue&type=script&lang=js&"
import style0 from "./giderGrup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./giderGrup.vue?vue&type=style&index=1&id=5853095e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853095e",
  null
  
)

export default component.exports